// moved to constant file since both modals need it now as description and technologies is optional
const descriptionPlaceholder =
    "[OPTIONAL] Brief description that highlights the project. These are used for Synergist analytics and not displayed on your resume.";
const technologiesPlaceholder =
    "[OPTIONAL] CSV of technologies used in this project: X,Y,Z...These are used for Synergist analytics and not displayed on your resume.";
const responsibilitiesPlaceholder =
    "[Do not add bullets, pdf generation will add them for you]\nList of statements of your responsibilities:\nDeveloper responsible for X.\nCreated a system that does cool things." +
    "\nSupplemental statements of things you accomplished: \nDid cool thing with Y that did Z. \nImproved performance by X.\netc...";
const projectNamePlaceholder =
    "[OPTIONAL] Name/Executive Summary of Project. i.e. Dataflow, Real Time Data Processing, etc..."

export {
    descriptionPlaceholder,
    technologiesPlaceholder,
    responsibilitiesPlaceholder,
    projectNamePlaceholder,
};
